export enum THEME {
    LIGHT = "light",
    DARK = "dark",
}

export enum LANG {
    ES = "es",
    EN = "en",
    RO = "ro",
    NL = "nl",
}
